import { Component, inject } from '@angular/core';
import { LoaderService } from 'app/services/loader.service';

@Component({
  selector: 'app-error',
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {
  _loaderService = inject(LoaderService);

  constructor(){
    this._loaderService.hide();
  }

}
